// extracted by mini-css-extract-plugin
export default {"container":"Header_container__zmwVK","logoContainer":"Header_logoContainer__tg0-i","linksContainer":"Header_linksContainer__J54DC","pragmate":"Header_pragmate__rjOMz"};